import React from 'react';
const getClasses = (props) => {
    let classNames = 'text';
    if (props.color) {
        classNames = `${classNames} ${props.color}`;
    }
    else {
        classNames = `${classNames} black`;
    }
    if (props.centered) {
        classNames = `${classNames} centered`;
    }
    return classNames;
};
const Text = {
    Base: (props) => {
        return (React.createElement("div", { className: `base ${getClasses(props)}`, "data-testid": "text_base" }, props.children));
    },
    Button: (props) => {
        return (React.createElement("div", { className: `base bold ${getClasses(props)}`, "data-testid": "text_button" }, props.children));
    },
    Small: (props) => {
        return (React.createElement("div", { className: `small ${getClasses(props)}`, "data-testid": "text_small" }, props.children));
    },
    Large: (props) => {
        return (React.createElement("div", { className: `large ${getClasses(props)}`, "data-testid": "text_large" }, props.children));
    },
    Bold: (props) => {
        return (React.createElement("div", { className: `bold ${getClasses(props)}`, "data-testid": "text_bold" }, props.children));
    },
    H1: (props) => {
        return (React.createElement("div", { className: `h1 ${getClasses(props)}`, "data-testid": "text_h1" }, props.children));
    },
    H2: (props) => {
        return (React.createElement("div", { className: `h2 ${getClasses(props)}`, "data-testid": "text_h2" }, props.children));
    },
};
export default Text;
